import React from 'react';
import PropTypes from 'prop-types';

/**
 * Primary UI component for user interaction
 */
export const Button = ({ buttonType, size, hasIcon = false, isIcon = false, iconInFront = false, label, title, className, ...props }) => {
  return (
    <a className={`c-button c-button--${buttonType} c-button--${size} ${iconInFront ? 'c-button--reverse' : ''} ${isIcon ? size === 'small' ? 'c-button--icon c-button--icon-small' : 'c-button--icon c-button--icon-large' : ''} ${className ? className : ''}`} title={title ? title : "button"} {...props}>
      {!isIcon && <span>{label} {hasIcon && (!props.icon ? <i className={`fa-light fa-arrow-right ${iconInFront ? 'a-icon--front' : 'a-icon--back'}`}></i> : props.icon)}</span>}
      {isIcon && (!props.icon ? <i className={`fas fa-caret-right`}></i> : props.icon)}
    </a>
  );
};

Button.propTypes = {
  /**
   * The type of button
   */
  buttonType: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  /**
   * Does the button have an icon?
   */
  hasIcon: PropTypes.bool,
  /**
   * Is the icon in the front or the back?
   */
  iconInFront: PropTypes.bool,
  /**
   * Is it an icon button?
   */
  isIcon: PropTypes.bool,
  /**
   * How large should the button be?
   */
  size: PropTypes.oneOf(['small', 'large']),
  /**
   * Button contents
   */
  label: PropTypes.string,
  /**
   * Optional click handler
   */
  onClick: PropTypes.func,
  /**
   * Optional title
   */
  title: PropTypes.string,

  /**
   * Icon to display
   */
  icon: PropTypes.node,
};

Button.defaultProps = {
  buttonType: 'primary',
  size: 'large',
  hasIcon: false,
  iconInFront: false,
  onClick: undefined,
  isIcon: false,
  title: 'title'
};
